import React, { useState } from "react";
import { Form, Row, Col, DatePicker } from "antd";
import { useForm } from "antd/es/form/Form";
import { CalendarIcon, ClockIcon } from "../assets";
import { Dayjs } from "dayjs";
import { Moment } from "moment";
import {
  setAtcFilterValue,
  setFilterValues,
} from "../redux/apiSlice/commonSlice";
import { useDispatch } from "react-redux";

export type FilterQueryParams = {
  from: number;
  to: number;
};

type Props = {
  popup: any;
  extraFormItem?: React.ReactNode;
};

type FilterFormType = {
  from_date: Moment;
  from_time: Moment;
  to_date: Moment;
  to_time: Moment;
  atc_id?: string;
};

const mergeDateTimeToTimestamp = (values: { date: Moment; time: Moment }) => {
  const combinedDateTime = values.date
    .hour(values.time.hour())
    .minute(values.time.minute())
    .second(values.time.second());
  const timestampInSeconds = combinedDateTime.unix();
  return timestampInSeconds;
};

const FilterForm: React.FC<Props> = ({ popup, extraFormItem }: Props) => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState<Dayjs | null>(null);
  const [fromTime, setFromTime] = useState<Dayjs | null>(null);

  const onFinish = async (values: FilterFormType) => {
    const from: number = mergeDateTimeToTimestamp({
      date: values.from_date,
      time: values.from_time,
    });
    const to: number = mergeDateTimeToTimestamp({
      date: values.to_date,
      time: values.to_time,
    });

    const queryParams: FilterQueryParams = { from, to };
    dispatch(setFilterValues(queryParams));
    if (values.atc_id) {
      dispatch(setAtcFilterValue({ atc_id: values.atc_id }));
    }
    popup.close();
  };

  const handleFromDateChange = (date: Dayjs | null) => {
    setFromDate(date);
  };

  const handleFromTimeChange = (time: Dayjs | null) => {
    setFromTime(time);
  };

  const disabledDateTo = (current: Dayjs) => {
    return fromDate ? current && current.isBefore(fromDate, "day") : false;
  };

  const disabledTimeTo = () => {
    if (!fromTime) return {};
    const hours = fromTime.hour();
    const minutes = fromTime.minute();
    return {
      disabledHours: () => Array.from({ length: hours }, (_, i) => i),
      disabledMinutes: (selectedHour: number) =>
        selectedHour === hours
          ? Array.from({ length: minutes }, (_, i) => i)
          : [],
    };
  };

  const checkAndSubmit = async () => {
    const values = await form.getFieldsValue();
    let isAllField = true;
    Object.keys(values).forEach((key) => {
      if (values[key] === undefined) {
        isAllField = false;
      }
    });
    if (isAllField) form.submit();
  };

  return (
    <>
      <div className="full-width-divider">
        <h5>Filter</h5>
      </div>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        // onFieldsChange={checkAndSubmit}
        onValuesChange={checkAndSubmit}
        // onChange={checkAndSubmit}
      >
        <Row style={{ marginTop: "15px" }} justify={"center"}>
          <Col span={18}>
            <h5>Date Range</h5>
          </Col>
          <Col span={18} style={{ marginTop: "10px" }}>
            <Row className="filter_date_range" gutter={[20, 20]}>
              <Col span={12}>
                <Form.Item label="From" name="from_date">
                  <DatePicker
                    placeholder="DD/MM/YYYY"
                    className="full-width"
                    format="DD/MM/YYYY"
                    suffixIcon={<CalendarIcon />}
                    onChange={handleFromDateChange}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label=" " name="from_time">
                  <DatePicker
                    placeholder="hh:mm A"
                    className="full-width"
                    picker="time"
                    format="hh:mm A"
                    suffixIcon={<ClockIcon />}
                    onChange={handleFromTimeChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="filter_date_range" gutter={[20, 20]}>
              <Col span={12}>
                <Form.Item label="To" name="to_date">
                  <DatePicker
                    placeholder="DD/MM/YYYY"
                    className="full-width"
                    format="DD/MM/YYYY"
                    suffixIcon={<CalendarIcon />}
                    disabledDate={disabledDateTo}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label=" " name="to_time">
                  <DatePicker
                    placeholder="hh:mm A"
                    className="full-width"
                    picker="time"
                    format="hh:mm A"
                    suffixIcon={<ClockIcon />}
                    disabledTime={disabledTimeTo}
                  />
                </Form.Item>
              </Col>
            </Row>
            {extraFormItem ? extraFormItem : null}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FilterForm;
